<template>
    <ul class="pagination">

        <li v-if="currentPage !== 1" :class="['page-item']">
            <a class="page-link" :href="getPageLink(1)">1</a>
        </li>

        <li v-if="currentPage > 3" class="page-item">...</li>

        <li v-if="currentPage > 2" :class="['page-item']">
            <a class="page-link" :href="getPageLink(currentPage - 1)">{{ currentPage - 1 }}</a>
        </li>

        <li v-if="currentPage" :class="['page-item', 'active']">
            <a class="page-link">{{ currentPage }}</a>
        </li>

        <li v-if="currentPage && (currentPage < (totalPages - 1))" :class="['page-item']">
            <a class="page-link" :href="getPageLink(currentPage + 1)">{{ currentPage + 1 }}</a>
        </li>

        <li v-if="(currentPage < (totalPages - 2))" class="page-item">...</li>

        <li v-if="currentPage !== totalPages" :class="['page-item']">
            <a class="page-link" :href="getPageLink(totalPages)">{{ totalPages }}</a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "Pagination",
        props: {
            currentPage: {
                type: Number,
                required: true
            },
            totalPages: {
                type: Number,
                required: true
            },
            pageName: {
                type: String,
                required: false,
                default: 'page',
            }
        },
        methods: {
            getPageLink (pageNo) {
                let _this = this,
                    params = [];

                if (location.search) {
                    params = location.search.substring(1)
                        .split("&")
                        .filter((param) => param.split("=")[0] !== _this.pageName);
                }

                if (pageNo > 1) {
                    params.push(_this.pageName + '=' + pageNo);
                }

                return location.pathname + (params.length ? '?' + params.join('&') : '');
            },

            setPage (pageNo) {
                this.$emit('setPage', pageNo);
                window.scrollTo({ top: 0 });
            }
        }

    }
</script>
